import { ValueOf } from 'ts-essentials';

type Entries<T extends object> = Array<[keyof T, ValueOf<T>]>;
export const entries = <T extends object>(obj: T): Entries<T> => Object.entries(obj) as Entries<T>;
